import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { environment } from "src/environments/environment";


@Injectable({
  providedIn: "root"
})
export class ApplicationUpdatesService {
  private baseurl = environment.apiConfig.apiUrl;

  constructor(private http: HttpClient) {}

  getUpdatedApplications(): Observable<any> {
    try {
      return this.http.get(this.baseurl + "/applicationupdates/queue");
    } catch (err) {
      console.log("This is update error");
      this.handleError(err);
    }
  }

  getSelectedApplication(id): Observable<any> {
    try {
      return this.http.get(this.baseurl + "/applicationupdates/" + id);
    } catch (err) {
      console.log("This is select error");
      this.handleError(err);
    }
  }

  getChatData(id): Observable<any> {
    try {
      return this.http.post(this.baseurl + "/applicationupdates/chatData", {
        Id: id
      });
    } catch (err) {
      console.log("This is select error");
      this.handleError(err);
    }
  }

  private handleError(err: HttpErrorResponse) {
    let errorMessage = "";

    // The backend returned an unsuccessful response code.
    // The response body may contain clues as to what went wrong,
    errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;

    console.error(errorMessage);
    return throwError(errorMessage);
  }
}
